import type { ParsedGame } from "@onchainreps/chess";
import type { MoveReview } from "../lib/analysis";

interface MoveTableProps {
  game: ParsedGame;
  reviews: MoveReview[];
  currentPly: number;
  onSelect: (ply: number) => void;
}

export function MoveTable({ game, reviews, currentPly, onSelect }: MoveTableProps) {
  const reviewByPly = new Map(reviews.map((review) => [review.ply, review]));
  const rows: Array<{ number: number; white?: { san: string; ply: number }; black?: { san: string; ply: number } }> = [];

  game.moves.forEach((move) => {
    const index = Math.floor(move.ply / 2);
    rows[index] ??= { number: move.moveNumber };
    if (move.color === "white") rows[index].white = { san: move.san, ply: move.ply };
    else rows[index].black = { san: move.san, ply: move.ply };
  });

  return (
    <div className="movelist">
      {rows.map((row) => (
        <div className="movelist__row" key={row.number}>
          <div className="movelist__num">{row.number}</div>
          {row.white ? (
            <MoveButton
              san={row.white.san}
              ply={row.white.ply}
              category={reviewByPly.get(row.white.ply)?.category}
              active={currentPly === row.white.ply + 1}
              onSelect={onSelect}
            />
          ) : (
            <div />
          )}
          {row.black ? (
            <MoveButton
              san={row.black.san}
              ply={row.black.ply}
              category={reviewByPly.get(row.black.ply)?.category}
              active={currentPly === row.black.ply + 1}
              onSelect={onSelect}
            />
          ) : (
            <div />
          )}
        </div>
      ))}
    </div>
  );
}

interface MoveButtonProps {
  san: string;
  ply: number;
  category: string | undefined;
  active: boolean;
  onSelect: (ply: number) => void;
}

function MoveButton({ san, ply, category, active, onSelect }: MoveButtonProps) {
  return (
    <button
      className={`move ${active ? "move--active" : ""}`}
      onClick={() => onSelect(ply + 1)}
      aria-current={active ? "true" : undefined}
    >
      <span className="move__san">{san}</span>
      {category && category !== "best" ? (
        <span className={`move__mark move__mark--${category}`} aria-label={category} />
      ) : null}
    </button>
  );
}
